$(document).ready(function() {
    class Survey {
        constructor() {
            this.container = document.querySelector('#survey');
            this.mask = App.Interface.Mask;
            this.survey = this.container.querySelector('.survey');
            this.submitSlide = this.survey.querySelector('.submit-survey');
            this.successSlide = this.survey.querySelector('.success');
            this.surveyBottom = this.container.querySelector('.survey-bottom');
            this.progress = this.surveyBottom.querySelector('.TextProgressbar');
            this.progressLine = this.surveyBottom.querySelector('.active-line');
            this.progressTitle = this.surveyBottom.querySelector('.progress-title strong');
            this.buttons = this.surveyBottom.querySelector('.survey-buttons');
            this.backButton = this.buttons.querySelector('#back');
            this.continueButton = this.buttons.querySelector('#continue');
            this.submitButton = this.container.querySelector('#submit');
            this.flavorFlower = this.container.querySelector('.flavor-flower');
            this.flavorFlowerSvg = this.flavorFlower.querySelector('svg');
            this.groups = [];
            this.checkedCheckboxes = [];

            this.initialize();
            this.bind();
        }

        get slides() {
            const slides = [];
            let items = Array.from(this.survey.querySelectorAll(':scope > div'));

            if (items.includes(this.successSlide)) {
                items.splice(items.indexOf(this.successSlide), 1);
            }

            for (const item of items) {
                slides.push({
                    slug: item.id,
                    name: item.dataset.name
                });
            }

            return slides;
        }

        continueToNextSlide(event) {
            event.preventDefault();
            const active = this.survey.querySelector(':scope > div.active');
            let userPressedEnter = false;

            if (event.target.type === 'text') {
                userPressedEnter = true;
            }

            if ((event.target === this.continueButton || event.target === this.backButton) || userPressedEnter) {
                const target = userPressedEnter ? this.continueButton.href.split('#')[1] : event.target.href.split('#')[1];
                const newActive = this.survey.querySelector('#' + target);
                const index = this.slides.findIndex(slide => slide.slug == target);

                active.classList.remove('active');
                active.classList.add('hidden');
                newActive.classList.remove('hidden');
                newActive.classList.add('active');

                this.progressTitle.textContent = this.slides[index].name + ' (' + (index + 1) + '/' + this.slides.length + ')';

                // update progress bar whenever we go back and forth in the survey
                this.progressLine.classList.forEach(name => {
                    if (name.startsWith('step-')) {
                        this.progressLine.classList.remove(name);
                        this.progressLine.classList.add('step-' + (index + 1));

                        App.Components.TextProgressbar.animateTextProgressbar();
                    }
                });

                if (userPressedEnter) {
                    this.backButton.href = '#' + this.slides[index - 1].slug;
        
                    // hide continueButton on the last slide
                    if (index + 1 === this.slides.length) {
                        this.continueButton.parentElement.classList.add('hidden');
                        this.submitButton.parentElement.classList.remove('hidden');
                    } else {
                        this.continueButton.href = '#' + this.slides[index + 1].slug;
                    }

                    if (this.backButton.classList.contains('hidden')) {
                        this.backButton.classList.remove('hidden');
                    }

                    // set the continueButton back to disabled when switching to a new slide
                    // the inputs will determine if the button can be enabled again
                    this.continueButton.classList.add('disabled');
                    this.continueButton.dataset.type = 'disabled';
                }

                switch (event.target) {
                    case this.continueButton:
                        this.backButton.href = '#' + this.slides[index - 1].slug;

                        // hide continueButton on the last slide
                        if (index + 1 === this.slides.length) {
                            this.continueButton.parentElement.classList.add('hidden');
                            this.submitButton.parentElement.classList.remove('hidden');
                        } else {
                            event.target.href = '#' + this.slides[index + 1].slug;
                        }

                        if (this.backButton.classList.contains('hidden')) {
                            this.backButton.classList.remove('hidden');
                        }

                        // set the continueButton back to disabled when switching to a new slide
                        // the inputs will determine if the button can be enabled again
                        this.continueButton.classList.add('disabled');
                        this.continueButton.dataset.type = 'disabled';

                        break;
                    case this.backButton:
                        // hide the backButton on the first slide
                        if (index === 0) {
                            this.backButton.classList.add('hidden');
                        } else {
                            event.target.href = '#' + this.slides[index - 1].slug;
                        }

                        // hide submitButton and show continueButton
                        // when going back from the last slide
                        if (index + 2 === this.slides.length) {
                            this.continueButton.parentElement.classList.remove('hidden');
                            this.submitButton.parentElement.classList.add('hidden');
                        }

                        this.continueButton.href = '#' + this.slides[index + 1].slug;
                        break;
                }

                // toggle buttons on the newly activated slide
                if (newActive.attributes.required) {
                    newActive.querySelectorAll('input').forEach(input => {
                        if (target !== 'split') {
                            if (index + 1 < this.slides.length) {
                                this.toggleContinueButton(input, this.continueButton);
                            }
                        }
                    });
                } else {
                    this.continueButton.classList.remove('disabled');
                    this.continueButton.dataset.type = 'button';
                }

                // if there's a split in the survey we need to display the selected option in the slide coming right before it
                if (target === 'split') {
                    const splitId = this.survey.querySelector('#' + this.slides[index - 1].slug + ' input[type="radio"]:checked').id;
                    const splitItem = newActive.querySelector('#' + splitId);

                    if (splitItem.attributes.required) {
                        splitItem.querySelectorAll('input').forEach(input => {
                            this.toggleContinueButton(input, this.continueButton);
                        });
                    } else {
                        this.continueButton.classList.remove('disabled');
                        this.continueButton.dataset.type = 'button';
                    }

                    Array.from(newActive.children).forEach(split => {
                        split.classList.add('hidden');
                    });

                    splitItem.classList.remove('hidden');
                    this.progressTitle.textContent = splitItem.dataset.name + ' (' + (index + 1) + '/' + this.slides.length + ')';

                    newActive.querySelectorAll('.hidden').forEach(hidden => {
                        hidden.querySelectorAll('input').forEach(input => {
                            input.checked = false;

                            if (Array.from(hidden.children).includes(this.flavorFlower)) {
                                this.flavorFlower.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                                    const petal = checkbox.id.toUpperCase();
                                    this.checkedCheckboxes = this.togglePetals(checkbox, checkbox.id, App.Interface.Colors.flavour[petal], App.Interface.Colors.flavourPastel[petal]);
                                });
                            }
                        });
                    });
                }
            }
        }

        toggleContinueButton(target, targetButton) {
            switch (target.type) {
                case 'text':
                    const error = target.closest('.input-field').dataset.error;

                    if (parseInt(target.min) > 0) {
                        if (parseInt(target.value) >= parseInt(target.min)) {
                            App.Components.wait(this.container, 'Instance', (Group) => {
                                Group.groups[target.name].removeNotification();
                            });

                            targetButton.classList.remove('disabled');
                            targetButton.dataset.type = 'button';
                        } else {
                            if (error && target.value) {
                                App.Components.wait(this.container, 'Instance', (Group) => {
                                    Group.groups[target.name].setNotification(error, 'error');
                                });
                            }

                            targetButton.classList.add('disabled');
                            targetButton.dataset.type = 'disabled';
                        }
                    } else if (target.value.length > 0) {
                        targetButton.classList.remove('disabled');
                        targetButton.dataset.type = 'button';
                    } else {
                        targetButton.classList.add('disabled');
                        targetButton.dataset.type = 'disabled';
                    }
                    break;
                case 'email':
                    if (target.value.length > 0 && App.Interface.Utilities.validateEmail(target.value)) {
                        targetButton.classList.remove('disabled');
                        targetButton.dataset.type = 'button';
                    } else {
                        targetButton.classList.add('disabled');
                        targetButton.dataset.type = 'disabled';
                    }
                    break;
                case 'checkbox':
                    const active = target.closest('.active');
                    let activeBoxes = null,
                        resetElements = null,
                        activeInputs = null
                    ;

                    if (active) {
                        activeBoxes = active.querySelectorAll('input[type="checkbox"]:checked');
                        resetElements = Array.from(active.querySelectorAll('.reset-selection'));
                        activeInputs = active.querySelectorAll('input');
                    }

                    if (activeBoxes) {
                        // check if the current slide requires the user to select from multiple form groups
                        if (active.dataset.groups > 0) {
                            const groupIndex = this.groups.findIndex(group => group.slide == active.id),
                                expectedGroups = this.groups[groupIndex].groups.sort(),
                                activeGroup = target.closest('[data-group]').dataset.group,
                                activeGroupInputs = active.querySelectorAll(`[data-group="${activeGroup}"] input`),
                                activeInputsOfOtherGroups = active.querySelectorAll(`[data-group]:not([data-group="${activeGroup}"]) input`),
                                activeGroups = []
                            ;

                            activeBoxes.forEach(box => {
                                const group = box.closest('[data-group]').dataset.group;

                                if (!activeGroups.includes(group)) {
                                    activeGroups.push(group);
                                }
                            });

                            activeGroups.sort();

                            if (resetElements.length > 0) {
                                const resetElement = active.querySelector(`.reset-selection[data-group="${activeGroup}"] input`);

                                if (resetElements.includes(target.closest('.form-group'))) {
                                    activeGroupInputs.forEach(aGI => {
                                        if (aGI !== target && resetElement.checked) {
                                            aGI.checked = false;
                                        }

                                        activeInputsOfOtherGroups.forEach(aIOOG => {
                                            if (aGI.value === aIOOG.value && aIOOG.disabled) {
                                                aIOOG.disabled = false;
                                            }
                                        });
                                    });
                                } else if (target.checked && resetElement.checked) {
                                    resetElement.checked = false;
                                }

                                activeGroupInputs.forEach(aGI => {
                                    activeInputsOfOtherGroups.forEach(aIOOG => {
                                        if (aGI.value === aIOOG.value) {
                                            if (aGI.checked && !aIOOG.disabled) {
                                                aIOOG.disabled = true;
                                            } else if (aIOOG.checked && !aGI.disabled) {
                                                aGI.disabled = true;
                                            }
                                        }
                                    });
                                });
                            }

                            const limitReached = (activeGroups.length == expectedGroups.length) && activeGroups.every(function(element, index) {
                                return element === expectedGroups[index];
                            });

                            if (limitReached) {
                                targetButton.classList.remove('disabled');
                                targetButton.dataset.type = 'button';
                            } else {
                                targetButton.classList.add('disabled');
                                targetButton.dataset.type = 'disabled';
                            }
                        } else {
                            if (resetElements.length > 0) {
                                const resetElement = active.querySelector('.reset-selection input');

                                if (resetElements.includes(target.closest('.form-group'))) {
                                    activeBoxes.forEach(box => {
                                        if (box !== target && resetElement.checked) {
                                            box.checked = false;
                                        }
                                    });
                                } else if (target.checked && resetElement.checked) {
                                    resetElement.checked = false;
                                }

                                if (resetElement === target && !target.checked) {
                                    targetButton.classList.add('disabled');
                                    targetButton.dataset.type = 'disabled';
                                }
                            }

                            if (target.checked) {
                                targetButton.classList.remove('disabled');
                                targetButton.dataset.type = 'button';
                            }
                        }
                    } else {
                        targetButton.classList.add('disabled');
                        targetButton.dataset.type = 'disabled';
                    }

                    if (activeInputs) {
                        activeInputs.forEach(input => {
                            if (!input.checked) {
                                if (target.checked && target.value == input.value) {
                                    input.disabled = true;
                                } else if (target.value == input.value) {
                                    input.disabled = false;
                                }
                            }
                        });
                    }
                    break;
                default:
                    if (target.closest('.active').querySelectorAll('input[type="radio"]:checked').length > 0) {
                        targetButton.classList.remove('disabled');
                        targetButton.dataset.type = 'button';
                    }
                    break;
            }
        }

        togglePetals(checkbox, id, color, colorPastel) {
            if (!checkbox.checked) {
                if (this.checkedCheckboxes.includes(id)) {
                    this.checkedCheckboxes.splice(this.checkedCheckboxes.indexOf(id), 1);
                }

                checkbox.nextSibling.style.color = color;

                this.flavorFlowerSvg.querySelectorAll('.' + id).forEach(path => {
                    path.attributes.fill.value = colorPastel;
                });
            }

            if (this.checkedCheckboxes.length < 2) {
                if (checkbox.checked) {
                    if (!this.checkedCheckboxes.includes(id)) {
                        this.checkedCheckboxes.push(id);
                    }

                    checkbox.nextSibling.style.color = colorPastel;

                    this.flavorFlowerSvg.querySelectorAll('.' + id).forEach(path => {
                        path.attributes.fill.value = color;
                    });
                }
            } else {
                checkbox.checked = false;
            }

            return this.checkedCheckboxes;
        }

        pushFormData(data) {
            const array = [];

            data.forEach(item => {
                if (item !== null) {
                    array.push(item);
                }
            });

            return array;
        }

        initialize() {
            // sometimes the browser remembers what the user entered in the form
            // to avoid having the full form filled out but all continue buttons disabled
            // we need to make several checks, starting with the first available slide

            // toggle continueButton on first slide
            const firstSlide = this.survey.firstChild;

            if (firstSlide.attributes.required) {
                firstSlide.querySelectorAll('input').forEach(input => {
                    this.toggleContinueButton(input, this.continueButton);
                });
            } else {
                this.continueButton.classList.remove('disabled');
                this.continueButton.dataset.type = 'button';
            }

            // toggle submitButton on last slide
            if (this.submitSlide.querySelector('input[type="email"]')) {
                this.submitSlide.querySelectorAll('input[type="email"]').forEach(input => {
                    this.toggleContinueButton(input, this.submitButton);
                });
            } else {
                this.submitSlide.querySelectorAll('input').forEach(input => {
                    this.toggleContinueButton(input, this.submitButton);
                });
            }
        }

        bind() {
            this.slides.forEach(slide => {
                const currentSlide = this.survey.querySelector('#' + slide.slug);
                const data = currentSlide.querySelectorAll('[data-group]');

                // check if the current slide requires the user to select from multiple form groups
                // collect the group names for future use
                if (data) {
                    data.forEach(item => {
                        const groupName = item.dataset.group;
                        const groupIndex = this.groups.findIndex(group => group.slide == slide.slug);

                        if (groupIndex < 0) {
                            this.groups.push({
                                slide: slide.slug,
                                groups: [groupName]
                            });
                        } else if (this.groups.findIndex(group => group.groups.includes(groupName)) < 0) {
                            this.groups[groupIndex].groups.push(groupName);
                        }
                    });
                }

                // give each input an eventlistener to toggle the continue or submit button
                currentSlide.addEventListener('input', event => {
                    if (currentSlide === this.submitSlide) {
                        this.toggleContinueButton(event.target, this.submitButton);
                    } else {
                        this.toggleContinueButton(event.target, this.continueButton);
                    }
                });

                currentSlide.addEventListener('keydown', event => {
                    // prevent the form being submitted prematurely when the user presses enter in a text input
                    if (event.target.type === 'text' || event.target.type === 'email') {
                        if (event.keyCode == 13) {
                            event.preventDefault();
                            this.continueToNextSlide(event);
                            return false;
                        }
                    }
                });
            });

            this.buttons.addEventListener('click', event => {
                this.continueToNextSlide(event);
            });

            // toggle flower petals
            this.flavorFlower.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                const petal = checkbox.id.toUpperCase();

                // timeout needed because it takes time for the flower to get its initial colors
                // without the timeout selected petals will have invisible text, as only the text color of the labels will be applied
                setTimeout(() => {
                    this.checkedCheckboxes = this.togglePetals(checkbox, checkbox.id, App.Interface.Colors.flavour[petal], App.Interface.Colors.flavourPastel[petal]);
                }, 400);

                checkbox.addEventListener('click', event => {
                    this.checkedCheckboxes = this.togglePetals(checkbox, checkbox.id, App.Interface.Colors.flavour[petal], App.Interface.Colors.flavourPastel[petal]);
                });
            });

            this.submitButton.addEventListener('click', event => {
                event.preventDefault();

                if (!this.successSlide && !this.mask.active) {
                    this.container.classList.add('hidden');
                    this.mask.fixed().large().transparent().setMessage(__('MIXER.QUESTION.LOADING'));
                }

                const formData = new FormData(this.container);
                let tasteData = [
                        formData.get('sweet'),
                        formData.get('creamy'),
                        formData.get('sour'),
                        formData.get('crunchy'),
                        formData.get('savoury')
                    ],
                    ingredientsLikedData = [
                        formData.get('like-chocolate'),
                        formData.get('like-fruits'),
                        formData.get('like-nuts')
                    ],
                    ingredientsDislikedData = [
                        formData.get('dislike-chocolate'),
                        formData.get('dislike-fruits'),
                        formData.get('dislike-nuts'),
                        formData.get('dislike-raisins')
                    ],
                    additionalAttributesData = [
                        formData.get('vegan'),
                        formData.get('no-milk'),
                        formData.get('grain'),
                        formData.get('sugar'),
                        formData.get('protein'),
                        formData.get('carbs'),
                        formData.get('fat'),
                        formData.get('fiber')
                    ],
                    allergiesData = [
                        formData.get('lactose'),
                        formData.get('gluten'),
                        formData.get('wheat'),
                        formData.get('nuts')
                    ]
                ;

                const tastePreferences = this.pushFormData(tasteData),
                    ingredientsLiked = this.pushFormData(ingredientsLikedData),
                    ingredientsDisliked = this.pushFormData(ingredientsDislikedData),
                    additionalAttributes = this.pushFormData(additionalAttributesData),
                    allergies = this.pushFormData(allergiesData)
                ;

                const data = {
                    'age': parseInt(formData.get('age')),
                    'frequency': parseInt(formData.get('breakfast')),
                    'boughtFor': formData.get('who') ? formData.get('who') : null,
                    'purpose': formData.get('product') ? formData.get('product') : 'taste',
                    'ingredientsLiked': ingredientsLiked,
                    'ingredientsDisliked': ingredientsDisliked,
                    'additionalAttributes': additionalAttributes,
                    'allergies': allergies
                };

                if (tastePreferences.length > 0) {
                    data.tastePreferences = tastePreferences;
                } else {
                    data.healthTarget = formData.get('goals');
                }

                App.Interface.Api.post(
                    'recommendations',
                    { 'get-results': true, },
                    data,
                    { contentType: 'application/json', },
                    response => {
                        if (this.successSlide) {
                            this.survey.querySelectorAll(':scope > div').forEach(slide => {
                                slide.classList.remove('active');
                                slide.classList.add('hidden');
                            });

                            this.surveyBottom.classList.add('hidden');
                            this.successSlide.classList.remove('hidden');
                            this.successSlide.classList.add('active');
                        } else {
                            window.location.href = '/muesli/recommendation/' + response.uid;
                        }
                    },
                    response => {
                        this.container.classList.add('hidden');
                        this.mask.fixed().large().transparent().error();
                        console.log(response);
                    }
                );
            });
        }
    }

    App.Survey = new Survey();
});